import React, { useEffect, useRef } from 'react';
interface MailerLiteFormProps {
  /** The MailerLite form code, e.g. "10BekE" */
  formId: string;
  className?: string;
}
/**
 * Renders MailerLite's official embedded form.
 *
 * The MailerLite Universal script (assets.mailerlite.com/js/universal.js) is
 * loaded once in App.tsx with account 2211088. That script scans the DOM for
 * `.ml-embedded[data-form]` elements on initial load — but in a single-page app
 * the div often mounts AFTER the script has already run (e.g. on client-side
 * route changes). To make sure the form always renders, we ping the universal
 * API to reload web forms once this component mounts, retrying until `ml` is
 * available.
 */
export function MailerLiteForm({
  formId,
  className = ''
}: MailerLiteFormProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let attempts = 0;
    let timer: number | undefined;
    const tryReload = () => {
      const ml = (window as any).ml;
      if (typeof ml === 'function') {
        try {
          ml('webforms', 'reload');
        } catch {
          // no-op — universal.js handles initial scan on its own
        }
        return;
      }
      // universal.js not ready yet — retry a few times
      if (attempts < 20) {
        attempts += 1;
        timer = window.setTimeout(tryReload, 250);
      }
    };
    tryReload();
    return () => {
      if (timer) window.clearTimeout(timer);
    };
  }, [formId]);
  return <div ref={containerRef} className={`ml-embedded ${className}`} data-form={formId} data-id="element-392" />;
}